<template>
  <DocumentsPage />
</template>

<script setup lang="ts">
import { generatePageMetaLinks } from '~/core/seo'
import { onlyRuPage } from '~/core/i18n'
import { DocumentsPage } from '~/features/documents'

definePageMeta({
  layout: 'sidebar',
  middleware: onlyRuPage,
})

useHead({
  link: generatePageMetaLinks({
    noAlternates: true,
  }),
})
</script>
